import { deliveredOrderDayKey, isOnOrAfterDay, todayKey, weekStartKey } from './dates';

export const orderSubtotal = (order) => {
  if (order.subtotal != null) return Number(order.subtotal);
  return (order.items || []).reduce(
    (s, i) => s + (Number(i.price) || 0) * (Number(i.qty) || 1),
    0,
  );
};

export const isCod = (order) => {
  const mode = (order.paymentMode || 'cash').toLowerCase();
  return mode === 'cash' || mode === 'cod';
};

export const paymentBadge = (order) =>
  isCod(order) ? { label: 'COD', icon: '💵' } : { label: 'Online', icon: '📱' };

export const isDeliveredForShop = (order, shopId) =>
  order.status === 'delivered' && order.shopId === shopId;

export const computeMerchantBalance = (orders, payouts, shopId) => {
  const deliveredSubtotal = orders
    .filter((o) => isDeliveredForShop(o, shopId))
    .reduce((s, o) => s + orderSubtotal(o), 0);

  const settledOut = payouts
    .filter((p) => p.merchantId === shopId && (p.status === 'paid' || p.status === 'pending'))
    .reduce((s, p) => s + (Number(p.amount) || 0), 0);

  return Math.max(0, deliveredSubtotal - settledOut);
};

export const sumDeliveredSubtotalOnDay = (orders, shopId, dayKey) =>
  orders
    .filter((o) => isDeliveredForShop(o, shopId) && deliveredOrderDayKey(o) === dayKey)
    .reduce((s, o) => s + orderSubtotal(o), 0);

export const sumDeliveredSubtotalSince = (orders, shopId, startKey) =>
  orders
    .filter((o) => {
      if (!isDeliveredForShop(o, shopId)) return false;
      const dk = deliveredOrderDayKey(o);
      return dk && isOnOrAfterDay(dk, startKey);
    })
    .reduce((s, o) => s + orderSubtotal(o), 0);

export const todayDeliveredSubtotal = (orders, shopId) =>
  sumDeliveredSubtotalOnDay(orders, shopId, todayKey());

export const weekDeliveredSubtotal = (orders, shopId) =>
  sumDeliveredSubtotalSince(orders, shopId, weekStartKey());

/** Delivered orders for one day — merchant subtotal split by COD vs online */
export const merchantDayCollection = (orders, shopId, dayKey) => {
  const result = {
    deliveries: 0,
    cod: { count: 0, subtotal: 0 },
    online: { count: 0, subtotal: 0 },
    orders: [],
  };
  orders.forEach((o) => {
    if (!isDeliveredForShop(o, shopId)) return;
    if (dayKey && deliveredOrderDayKey(o) !== dayKey) return;
    const sub = orderSubtotal(o);
    result.deliveries += 1;
    const bucket = isCod(o) ? result.cod : result.online;
    bucket.count += 1;
    bucket.subtotal += sub;
    result.orders.push(o);
  });
  result.orders.sort((a, b) => {
    const ta = a.deliveredAt?.toDate?.()?.getTime() || 0;
    const tb = b.deliveredAt?.toDate?.()?.getTime() || 0;
    return tb - ta;
  });
  result.totalSubtotal = result.cod.subtotal + result.online.subtotal;
  return result;
};
